import { get } from 'lodash'
import { card, cvc, expiration } from 'creditcards'

export const vNotEmpty = value =>
  value === undefined || value === null || value === '' ? "This can't be empty" : undefined

export const vChecked = value => (value !== true ? 'This is required' : undefined)

export const vRequired = value =>
  value === undefined || value === null ? 'This is required' : undefined

export const vFileRequired = value =>
  value === undefined || value === null || !get(value, 'id') ? 'This is required' : undefined

export const vEmail = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const vMobilePhone = value =>
  value && !/^04(\d{8})/.test(value) ? 'Must be mobile phone number (04xxxxxxxx)' : undefined

export const vDate = value => {
  const splitVal = value && value.split('/')
  const isValid =
    splitVal &&
    splitVal.length === 3 &&
    splitVal[0].length === 2 &&
    splitVal[1].length === 2 &&
    splitVal[2].length === 4

  return !isValid ? 'Format should be DD/MM/YYYY' : undefined
}

export const vPasswordIdentical = (val, { confirmPassword, password }) =>
  confirmPassword !== password ? 'Passwords not identical' : undefined

export const vNumberIntegerPositive = val => {
  if (val) {
    const valNum = parseInt(val, 10)
    if (!Number.isInteger(valNum)) {
      return 'Must be an integer'
    } else if (valNum < 0) {
      return 'Must be positive'
    }
  }
  return undefined
}

export const vAutosuggestIdentical = (key, message) => (val, otherVals) =>
  val !== otherVals[key] ? message : undefined

export const vMin = min => val => (val && val < min ? `Must be >= ${min}` : undefined)

export const vMax = max => val => (val && val > max ? `Must be <= ${max}` : undefined)

export const vAutoSuggestLength = (key, length, message) => (val, otherVals) => {
  const selectedVal = otherVals[key]
  const isIdentical = selectedVal === val
  if (isIdentical) {
    return undefined
  }
  return val && val.length > length ? message : undefined
}

export const vMaxLength = length => val =>
  val && val.length > length ? `Max length is ${length} characters` : undefined

export const vMinLength = length => val =>
  val && val.length < length ? `Min length is ${length} characters` : undefined

export const vMaxArrayLength = length => val =>
  val && val.length > length
    ? `Max number of items is ${length}. You have ${val.length}.`
    : undefined

export const vMinArrayLength = length => val =>
  val && val.length < length
    ? `Min number of items is ${length}. You have ${val.length}.`
    : undefined

const areaCodes = ['02', '03', '04', '07', '08']

export const vAreaCode = val =>
  areaCodes.some(areaCode => val && val.startsWith && val.startsWith(areaCode))
    ? undefined
    : 'Must start with an area code: 02, 03, 04, 07, or 08'

export const vStandardNumber = val => {
  const maxLength = vMaxLength(10)(val)
  if (maxLength) return maxLength

  const minLength = vMinLength(10)(val)
  if (minLength) return minLength

  const areaCode = vAreaCode(val)
  if (areaCode) return areaCode

  return undefined
}

export const v1300Number = val => {
  const length = vMaxLength(10)(val)
  if (length) return length

  return val && val.startsWith && val.startsWith('1300') ? undefined : 'Must start with 1300'
}

export const v1800Number = val => {
  const length = vMaxLength(10)(val)
  if (length) return length

  return val && val.startsWith && val.startsWith('1800') ? undefined : 'Must start with 1800'
}

export const vPassword = val => {
  if (val.length < 7) {
    return 'This must be at least 7 characters long'
  }
  if (val.search(/[a-z]/i) < 0) {
    return 'Must contain at least 1 letter'
  }
  if (val.search(/[0-9]/) < 0) {
    return 'Must contain at least 1 number'
  }
  return undefined
}

export const vCreditCardNumber = val => {
  if (!card.isValid(val)) {
    return 'Invalid number'
  }
  return undefined
}

export const vCreditCardCvc = val => {
  if (!cvc.isValid(val)) {
    return 'Invalid CVC'
  }
  return undefined
}

export const vCreditCardMonth = val => {
  if (!expiration.month.isValid(parseInt(val))) {
    return 'Invalid month'
  }
  return undefined
}

export const vCreditCardYear = val => {
  if (expiration.year.isPast(val)) {
    return 'This card has expired'
  }
  if (!expiration.year.isValid(parseInt(val))) {
    return 'Invalid year'
  }
  return undefined
}

export const v24HourTime = val => {
  const valSplit = val && val.split && val.split(':')

  if (
    val &&
    valSplit.length === 2 &&
    valSplit[0].length <= 2 &&
    valSplit[1].length <= 2 &&
    parseInt(valSplit[0], 0) <= 24 &&
    parseInt(valSplit[1], 0) < 60
  ) {
    return undefined
  }
  return 'Must be 24:00h time e.g. 17:00'
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Input.validations.js